// stores/audioStore.ts
import { defineStore } from 'pinia'
import { ref, computed, watch } from 'vue'

export const useLogStore = defineStore('log', () => {
  const logList = ref([])

  const sendLog = (group, message, ...other) => {
    const t = (new Date()).toISOString()
    console.log(t, group, message, other)
    logList.value.push(`${t} | ${group} | ${message}`) 
    if(logList.value.length > 200)
      logList.value.splice(0, 1)
  }

  return {
    logList,
    sendLog
  }
})
